/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/DefaultAttributes',[], function () {
	return {
		cornerColor: 'rgba(31, 87, 164, 1)',
		cornerSize: 8,
		cornerStrokeColor: 'rgba(31, 87, 164, 1)',
		cornerStyle: 'rect',
		hasBorders: true,
		rotatingPointOffset: 20,
		selectable: false,
		strokeWidth: 1,
		pointedDirection: '',
		transparentCorners: false,
		fontFamily: ''
	};
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

